import { render, staticRenderFns } from "./SideOnline.vue?vue&type=template&id=4bcfdc34&scoped=true"
import script from "./SideOnline.vue?vue&type=script&lang=js"
export * from "./SideOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcfdc34",
  null
  
)

export default component.exports